
export const gaGradCatalogBrowsePageLoad  = () => {
  window && !window.dataLayer && (window.dataLayer = []);
    window.dataLayer.push({
     "event": window.template === "COL-GRAD-ANNC" ? "COLAnnouncementsBrowsePageLoad": "GradCatalogBrowsePageLoad",
     "pageType": window?.gaPageType +" Catalog Browse",
     "schoolType": window?.affiliationData?.customerClassCode,
     "schoolId": window?.affiliationData?.affiliateId,
     "schoolName": window?.affiliationData?.name
   });
 };
   
 export const gaGradCatalogBrowseCustomizeClick  = (pageContentData,product,sectionOfPage) => {
  window && !window.dataLayer && (window.dataLayer = []);
  window.dataLayer.push({
    "event": window.template === "COL-GRAD-ANNC" ? "COLAnnouncementsCustomizeClick": "GradCatalogBrowseCustomizeClick",
    "pageType": window?.gaPageType +" Catalog Browse",
    "schoolType": window?.affiliationData?.customerClassCode,
    "schoolId": window?.affiliationData?.affiliateId,
    "schoolName": window?.affiliationData?.name,
    "packageId": product.productOsr,
    "packageOrderStepName":`Customize ${sectionOfPage} Button`,
    "packageType": pageContentData?.title==="Graduation Packages"?"Grad":pageContentData?.title==="Cap and Gown Packages"?"Cap & Gown":""
  });
};